import { Injectable } from '@angular/core';
import { AccountMembership, AccountMembershipDto } from '@mkp/account-membership/models';
import { Account } from '@mkp/account/models';
import { mapAuditDates } from '@mkp/shared/data-access';
import { decodePunycodeEmail } from '@mkp/shared/util-format';

@Injectable({ providedIn: 'root' })
export class AccountMembershipMapper {
  fromJson(dto: AccountMembershipDto<Account>): AccountMembership {
    const { _embedded, ...rest } = dto;
    return {
      ...rest,
      ...mapAuditDates(dto),
      canDelete: !!dto._links?.delete,
      account: _embedded.account,
      user: {
        ..._embedded.user,
        email: decodePunycodeEmail(_embedded.user.email),
      },
    };
  }
}
